export default __webpack_public_path__ + "media/wageningen.c84c5f27.png";